import { useEffect } from "react";
import "./App.css";
import { Toaster } from "sonner";
import { track } from "./lib/track";
import { Navbar } from "./components/site/Navbar";
import { Hero } from "./components/site/Hero";
import { Metrics } from "./components/site/Metrics";
import { Experience } from "./components/site/Experience";
import { ClientTicker } from "./components/site/ClientTicker";
import { Services } from "./components/site/Services";
import { Expertise } from "./components/site/Expertise";
import { Portfolio } from "./components/site/Portfolio";
import { Coverage } from "./components/site/Coverage";
import { Testimonials } from "./components/site/Testimonials";
import { Certifications } from "./components/site/Certifications";
import { ProfessionalTraining } from "./components/site/ProfessionalTraining";
import { Volunteering } from "./components/site/Volunteering";
import { Contact } from "./components/site/Contact";
import { Footer } from "./components/site/Footer";
import { Chatbot } from "./components/site/Chatbot";

function App() {
  useEffect(() => {
    track("page_view", window.location.pathname);
  }, []);

  return (
    <div className="App">
      <a href="#main" className="skip-link">Skip to content</a>
      <Navbar />
      <main id="main">
        <Hero />
        <Metrics />
        <Experience />
        <ClientTicker />
        <Services />
        <Expertise />
        <Portfolio />
        <Coverage />
        <Testimonials />
        <Certifications />
        <ProfessionalTraining />
        <Volunteering />
        <Contact />
      </main>
      <Footer />
      <Chatbot />
      <Toaster position="top-center" theme="dark" richColors />
    </div>
  );
}

export default App;
